var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserCollaborate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_642_10933)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.04457 7.04141C7.69314 7.04141 9.02957 5.70498 9.02957 4.05641C9.02957 2.40784 7.69314 1.07141 6.04457 1.07141C4.396 1.07141 3.05957 2.40784 3.05957 4.05641C3.05957 5.70498 4.396 7.04141 6.04457 7.04141Z",
    stroke: "white",
    strokeWidth: 1.71429,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0203 15C11.0203 12.2527 8.79312 10.0255 6.04578 10.0255C3.29845 10.0255 1.07129 12.2527 1.07129 15",
    stroke: "white",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9547 20.97C25.6033 20.97 26.9397 19.6336 26.9397 17.985C26.9397 16.3364 25.6033 15 23.9547 15C22.3062 15 20.9697 16.3364 20.9697 17.985C20.9697 19.6336 22.3062 20.97 23.9547 20.97Z",
    stroke: "white",
    strokeWidth: 1.71429,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9285 28.9285C28.9285 26.1812 26.7014 23.9541 23.9541 23.9541C21.2067 23.9541 18.9795 26.1812 18.9795 28.9285",
    stroke: "white",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9546 9.03065V8.03576C23.9546 5.83787 22.1728 4.05615 19.9749 4.05615H16.9902",
    stroke: "white",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.0459 20.9694V21.9642C6.0459 24.1622 7.82762 25.944 10.0255 25.944H13.0102",
    stroke: "white",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_642_10933"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCollaborate);
export default __webpack_public_path__ + "static/media/userCollaborate.6c52113b8830fb142fb2b335d37a788d.svg";
export { ForwardRef as ReactComponent };